@if (engine.error(); as message) {
  <section class="engine-error" role="alert">
    <h1>
      {{
        engine.loginRequired() ? "Sign in to play" : "Unable to load the wheel"
      }}
    </h1>
    <p>{{ message }}</p>
    @if (engine.loginRequired()) {
      <a [href]="engine.loginUrl()">Sign in</a>
      @if (engine.acceptsLaunchToken) {
        <form
          (submit)="
            $event.preventDefault(); engine.signInWithToken(launchToken.value)
          "
        >
          <label for="launch-token">Launch token</label>
          <input
            #launchToken
            id="launch-token"
            type="password"
            autocomplete="off"
            spellcheck="false"
            required
            [disabled]="engine.signingIn()"
          />
          <button type="submit" [disabled]="engine.signingIn()">
            {{ engine.signingIn() ? "Connecting…" : "Connect" }}
          </button>
        </form>
      }
    } @else {
      <button type="button" (click)="reload()">Try again</button>
    }
  </section>
} @else if (game$ | async) {
  <router-outlet></router-outlet>
}
